"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencyToIsoNumber = void 0;
exports.currencyToIsoNumber = {
    USD: 840,
    EUR: 978,
    GBP: 826,
    CAD: 124,
};
//# sourceMappingURL=currencyToIsoNumber.js.map